import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { TourNotifier } from './tour-notifier';
import { TourState } from './tour-state';

@Injectable()
export class TourProvider extends BaseProvider<TourNotifier, TourState> {
  constructor() {
    super(TourNotifier);
  }
}
